import { createApi } from "@reduxjs/toolkit/query/react";
import {
    type CreateUserPasswordRequest,
    type CreateUserPasswordResponse,
    type GetUserInfoResponse,
    type ResetUserPasswordConfirmRequest,
    type ResetUserPasswordConfirmResponse,
    type ResetUserPasswordRequest,
    type ResetUserPasswordResponse
} from "../contracts";
import { baseQueryWithAuth } from "./api";

export const userApi = createApi({
    reducerPath: "userApi",
    baseQuery: baseQueryWithAuth,
    endpoints: builder => ({
        isAuthenticated: builder.query<boolean, void>({
            query: () => ({
                url: "user/isAuthenticated",
                method: "POST"
            })
        }),
        getUserInfo: builder.mutation<GetUserInfoResponse, void>({
            query: () => ({
                url: "user/info",
                method: "POST",
                body: {}
            })
        }),
        resetPassword: builder.mutation<ResetUserPasswordResponse, ResetUserPasswordRequest>({
            query: body => ({
                url: "user/password/reset",
                method: "POST",
                body
            })
        }),
        resetPasswordConfirm: builder.mutation<ResetUserPasswordConfirmResponse, ResetUserPasswordConfirmRequest>({
            query: body => ({
                url: "user/password/reset/confirm",
                method: "POST",
                body
            })
        }),
        changePassword: builder.mutation<CreateUserPasswordResponse, CreateUserPasswordRequest>({
            query: body => ({
                url: "user/password/create",
                method: "POST",
                body
            })
        })
    })
});

export const {
    useGetUserInfoMutation,
    useChangePasswordMutation,
    useResetPasswordMutation,
    useResetPasswordConfirmMutation,
    useIsAuthenticatedQuery
} = userApi;
